import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'

const styles = {
    ctaBarPost: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        paddingVertical: 10,
        height: 35,
    },
}

export default styles
